/* Copyright (c) 2023-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Directive, ElementRef } from '@angular/core';
import { FocusManager } from '../../services/focus-manager';
import { SpatialNavigationDirection } from '../../services/spatial-navigation/spatial-navigation-polyfill';
import { SpatialNavigationService } from '../../services/spatial-navigation/spatial-navigation.service';

@Directive({
    selector: '[nvFastSpatialNavigationItem]',
    standalone: true
})
export class FastSpatialNavigationItemDirective {
    get focusableElement(): HTMLElement | null {
        this._focusableElement = this.spatialNavigationService.isFocusable(this._elementRef.nativeElement)
            ? this._elementRef.nativeElement
            : this.focusManager.getFirstFocusableChild(
                  this.elementRef.nativeElement,
                  this.spatialNavigationService.isFocusable.bind(this.spatialNavigationService)
              );
        return this._focusableElement;
    }
    private _focusableElement: HTMLElement | null = null;

    get elementRef() {
        return this._elementRef;
    }
    private _elementRef: ElementRef<HTMLElement>;

    constructor(
        elementRef: ElementRef<HTMLElement>,
        private focusManager: FocusManager,
        private spatialNavigationService: SpatialNavigationService
    ) {
        this._elementRef = elementRef;
    }

    focus(dir: SpatialNavigationDirection) {
        this.focusManager.navigateTo(this.focusableElement, dir);
    }
}
